export default __webpack_public_path__ + "static/media/Orccha-Bird-Sancturay.6950f3cd.jpg";